
import NiceModal from "@ebay/nice-modal-react";
import AuthProvider from "providers/AuthProvider";
import BrowserEventProvider from "providers/BrowserEventProvider";
import { useEffect } from "react";
import { ToastContainer } from "react-toastify";
import RootRouter from "router/RootRouter";
import BffRequester from "shared/BffRequester";

import Requester from "shared/Requester";

import style from "./App.module.css";
import iosBridge from "shared/utils/iosBridge";
import { AuthReducer } from "shared/redux/reducers/auth/AuthReducer";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

export const requester = new Requester();

export const bffRequester = new BffRequester();




function App() {

  const dispatch = useDispatch();
  const navigate = useNavigate();

  


  useEffect(() => {
    const disableScrollRestoration = () => {
      if ('scrollRestoration' in window.history) {
        window.history.scrollRestoration = 'manual';
      }
    };

    disableScrollRestoration();

    return () => {
      window.removeEventListener('beforeinstallprompt', () => { });
      if ('scrollRestoration' in window.history) {
        window.history.scrollRestoration = 'auto';
      }
    };
  }, []);

  useEffect(() => {
    iosBridge.setTokenResponse = (status) => {
      
      if (status === "success") {
        // 이후 라우팅 or 상태 변경
        navigate(`/ws/5/mobile/main`);
      } else {
        
      }
    };
  
    iosBridge.getTokenResponse = (token) => {
      if (token) {
        dispatch(AuthReducer.actions.setToken(token));
        
      } else {
        
      }
    };
  
    iosBridge.closeWebView = () => {
      window.history.back();
    };
  
    return () => {
      iosBridge.setTokenResponse = null;
      iosBridge.getTokenResponse = null;
      iosBridge.closeWebView = null;
    };
  }, []);

  return (
    <BrowserEventProvider>
      <div className={style.toast}>
        <ToastContainer />
      </div>
      {/* <Loading isLoading={isLoading} /> */}
      <NiceModal.Provider>
        <AuthProvider>
          <RootRouter />
        </AuthProvider>
      </NiceModal.Provider>
    </BrowserEventProvider>
  );
}

export default App;